import { ref, shallowRef, unref, computed, watch } from 'vue'
import autotendData from '@/data/toutiao/auto_extend_targets'
import { getToutiaoTargetingForm } from '../../model/form.js'
import { getCustomAudience } from '@/api/toutiao.model'
import { adAccount } from '@/api/common.model'
import { getAccountById } from '@/api/ptom.data.model.js'
import { getTargetingDataById } from '@/api/manage.model'
import { AGE_TYPES, PLATFORM, TOUTIAO_AD_MARKETING_SCENE } from '../../model/toutiao_targeting_consts.js'
import { setLocal, getLocal } from '@/common/js/api.js'

export function getInitForm(props) {
  const { defaultPlatform, defaultAccount, adMarketingScene = TOUTIAO_AD_MARKETING_SCENE.VERSION_2 } = props || {}
  //  有默认账号使用默认账号，没有默认账号使用本地缓存账号
  // const account = defaultAccount?.id ? defaultAccount : getLocal('targetingFormAccount')
  const account = defaultAccount?.id ? defaultAccount : {}
  const form = {
    account: {}, // 选择的账号
    name: '', // 定向名称
    description: '', // 描述
    ...getToutiaoTargetingForm(account),
    ad_marketing_scene: adMarketingScene
  }

  if (defaultPlatform) {
    // 按应用平台映射定向受众平台：1安卓/2IOS/3小程序不限/5鸿蒙
    const platformMap = {
      [PLATFORM.ANDROID]: PLATFORM.ANDROID,
      [PLATFORM.IOS]: PLATFORM.IOS,
      [PLATFORM.UNLIMITED]: PLATFORM.UNLIMITED,
      [PLATFORM.HARMONY]: PLATFORM.HARMONY
    }
    // 小程序defaultPlatform=3 默认平台为不限PLATFORM.UNLIMITED
    form.platform = platformMap[defaultPlatform] || PLATFORM.UNLIMITED
  }
  if (account?.id) {
    form.account = account
  }

  return form
}
const targetingForm = ref({})

const moreAges = [
  AGE_TYPES.AGE_BETWEEN_18_19,
  AGE_TYPES.AGE_BETWEEN_20_23,
  AGE_TYPES.AGE_BETWEEN_31_35,
  AGE_TYPES.AGE_BETWEEN_36_40,
  AGE_TYPES.AGE_BETWEEN_41_45,
  AGE_TYPES.AGE_BETWEEN_46_50,
  AGE_TYPES.AGE_BETWEEN_51_55,
  AGE_TYPES.AGE_BETWEEN_56_59,
  AGE_TYPES.AGE_ABOVE_60
]
// 智能放量可选值
const autotendList = shallowRef(autotendData)

/**
 * @description: 编辑定向，更新提交
 */
export function useTargetingFormEdit() {
  const initFormEdit = async (id) => {
    try {
      const data = await getTargetingDataById({ targetingId: id })
      const { targetingParamJson, accountIds, targetingName, targetingDesc } = data
      const accountInfo = await getAccountById({ ad_account_id: Number(accountIds) })
      const { age } = targetingParamJson
      let isMoreAge = false
      age.map((ag) => {
        if (moreAges.includes(ag)) {
          isMoreAge = true
        }
      })
      targetingForm.value = {
        ...targetingForm.value,
        ...targetingParamJson,
        targetingId: id,
        account: {
          name: accountInfo.adAccount,
          id: accountInfo.id
        },
        name: targetingName,
        description: targetingDesc,
        age: isMoreAge ? [AGE_TYPES.MORE] : age,
        moreAge: isMoreAge ? age : []
      }
      return Promise.resolve()
    } catch (e) {
      return Promise.reject(new Error('获取定向信息失败'))
    }
  }

  return {
    initFormEdit
  }
}

/**
 * @description: 账号列表处理
 * @return {*}
 */
export function useAccountList({ getAudienceData }) {
  const accountList = ref([])

  const getAccounts = () => {
    return adAccount({
      mediaId: 10,
      authFlag: 1
    }).then((data) => {
      accountList.value = data
    })
  }

  /**
   * @description: 切换账号
   */
  function onAccountChange(e) {
    // 切换账号时，构建人群包需要的value结构
    targetingForm.value.audiences = {
      [e.id]: {
        accountId: e.id,
        includes: [],
        excludes: []
      }
    }
    getAudienceData(e.id)
  }

  return {
    accountList,
    getAccounts,
    onAccountChange
  }
}

/**
 * @description: 初始化头条定向表单
 * @return {*}
 */
export function useInitialTargetingForm() {
  const cityData = shallowRef([])
  const androidVersions = shallowRef([])
  const IOSVersions = shallowRef([])
  const harmonyVersions = shallowRef([])
  const brandData = shallowRef([])

  targetingForm.value = { ...getInitForm() }
  ; (async function () {
    const [cities, android, ios, harmony, brands] = await Promise.all([
      fetch('/data/toutiao_cities.json').then((res) => res.json()),
      fetch('/data/toutiao_android_versions.json').then((res) => res.json()),
      fetch('/data/toutiao_ios_versions.json').then((res) => res.json()),
      fetch('/data/toutiao_harmony_versions.json').then((res) => res.json()),
      fetch('/data/toutiao_brand_categroy.json').then((res) => res.json())
    ])

    cityData.value = cities
    androidVersions.value = android
    IOSVersions.value = ios
    harmonyVersions.value = harmony
    brandData.value = brands
  })()

  /**
   * @description: 智能放量
   */
  const autotendRelatives = computed(() => {
    const { gender, district, age, audienceType, interest_action_mode } = targetingForm.value
    return {
      // REGION: district === 'NONE',
      GENDER: gender === 'NONE',
      AGE: age === 'NONE',
      CUSTOM_AUDIENCE: audienceType === 'NONE',
      INTEREST_ACTION: interest_action_mode === 'UNLIMITED'
    }
  })

  // 智能放量关联关系处理
  watch(
    () => autotendRelatives.value,
    (relatives) => {
      autotendData.value = unref(autotendData).map((item) => {
        if (relatives[item.key]) {
          return { ...item, disabled: true }
        }
        return { ...item, disabled: false }
      })
    }
  )

  return {
    targetingForm,
    cityData,
    brandData,
    androidVersions,
    IOSVersions,
    harmonyVersions,
    autotendList
  }
}

/**
 * @description: 智能放量
 */
export function useAutotend() {
  return {}
}

/**
 * @description: 兴趣行为定向
 */
export function useInterestActionBehavior() {
  const setDays = (val) => {
    targetingForm.value.action_days = val
  }

  const setScene = (val) => {
    targetingForm.value.action_scene = val
  }
  return {
    setDays,
    setScene
  }
}

/**
 * @description: 人群定向
 */
export function useAudience() {
  const audienceData = ref([])
  const onAudienceResultChange = (e) => {
    targetingForm.value.audiences = {
      [e.accountId]: e
    }
  }
  // 切换到定向或排除人群时，根据账号获取人群包
  const onAudienceTypeChange = () => {
    const { id } = targetingForm.value.account
    id && getAudienceData(id)
  }

  function getAudienceData(account) {
    getCustomAudience({
      account,
      select_type: 1,
      pageIndex: 1,
      pageSize: 100
    }).then((data) => {
      if (data?.success) {
        audienceData.value =
          data.models?.retData?.map((au) => {
            return {
              ...au,
              check: null,
              includesDisabled: false,
              excludesDisabled: false,
              groupId: au.custom_audience_id,
              groupName: au.name,
              userCount: au.cover_num
            }
          }) || []
      }
    })
  }

  return {
    audienceData,
    onAudienceResultChange,
    onAudienceTypeChange,
    getAudienceData
  }
}
